import React from "react";
import "./TeamCenterIntegrationSolidEdge.css";
import Teacher from "../../../../../assets/images/plmimplementationimage/Teacher-amico.png";
import Letsgetintouch from "../../../BusinessProcessAndChangeManagement/Letsgetintouch";
import TISolidEdgeOverview from "./TISolidEdgeOverview";
import FloatingContactUs from "../../../../floting_contact/FloatingContactUs";
import { NavLink } from "react-router-dom";

const TeamCenterIntegrationSolidEdge = () => {
  return (
    <section className="TINX-management">
      <div className="banner">
        <div className="banner-content">
          <img src={Teacher} alt="teacher" className="banner-image" />
          <div className="banner-text">
            <h4 className="TINX-process-h4">
              Teamcenter Integration for Solid Edge{" "}
            </h4>
          </div>
        </div>
      </div>
      <div>
         <FloatingContactUs />
      </div>

      <div className="container">
        <TISolidEdgeOverview />
        <div className="benefits">
          <h4 className="TINX-page-heading">Unlock the Power :</h4>
          <h5 className="TINX-subheading">
            Discover the Transformative Benefits of NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              Reduced time spent by technical staff finding correct CAD data
              revisions
            </li>
            <li>Consistent work processes across all data formats</li>
            <li>
              Faster product change and approval processes, reducing
              time-to-market
            </li>
            <li>
              Seamless integration of Solid Edge files with technical data,
              providing a single source of product information from design
              through manufacturing
            </li>
          </ul>
        </div>

        <div className="solutions container">
  <div className="solutions-content">
    <div className="row">
      {/* Left Section: TINX Solutions */}
      <div className="col-md-6 col-12">
        <h4 className="TINX-page-heading">Our Solutions</h4>
        <ul className="custom-bullets">
          <li>2TIER & 4TIER integration</li>
          <li>Synchronize title block using Teamcenter database attributes</li>
          <li>Mechanical Properties Synchronization</li>
          <li>Bidirectional Attribute Mapping</li>
          <li>Seed Parts configuration</li>
          <li>Server-based JT Translation from Solid Edge to JT</li>
        </ul>
      </div>

      {/* Right Section: Quick Links */}
      <div className="col-md-6 col-12">
        <div className="quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/solidwork-integration"}>
                Teamcenter Integration for SolidWorks
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/pro-engineer-integration"}>
                Teamcenter Integration for Creo Pro/ENGINEER
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/catia-integration"}>
                Teamcenter Integration for CATIA
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/autocad-integration"}>
                Teamcenter Integration for AutoCAD
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/nx-integration"}>
                Teamcenter Integration for NX
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration"}>
                MCAD Integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/ecad-integration"}>
                ECAD Integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/business-process-management"}>
                Business Process and Change Management
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


        <div className="solutions">
         

          <h4 className="TINX-page-heading">Performance Tuning</h4>
          <p className="plmimplementationparagraph">
            We ensure optimal performance by configuring the OS, hardware,
            server, and client system components correctly. This enables high
            performance during activities in Solid Edge’s managed mode,
            including smart saves, Teamcenter-driven CAD properties, SQL tuning,
            and more.
          </p>
          {/* <ul className="custom-bullets">
            <li>T4S, T40, and T4EA Installation </li>
            <li>
              Data flow modelling for business object and their lifecycle{" "}
            </li>
            <li>TCL programming for mapping </li>
            <li>T4S_Gateway explorer configuration </li>
            <li>Data Model Mapping of Teamcenter and SAP business objects </li>
            <li>Teamcenter and SAP Login configuration </li>
            <li>Configuration for MM & MBOM transfer </li>
            <li>
              Workflow Development for automatic transfer of MM & MBOM on
              receiving maturity{" "}
            </li>
            <li>
              Change management across the SAP & Teamcenter workflow development{" "}
            </li>
          </ul> */}
        </div>

        <div className="best-practices">
          <h4 className="TINX-page-heading">Best Practices</h4>
          <p className="plmimplementationparagraph">
            NexTech provides best practices for performing activities in
            managed-mode environments on Solid Edge data, including creating,
            configuring, editing models, drawings, assemblies, managing
            relationships and auxiliary files, JT conversion, storing mechanical
            properties, working in multiple sessions, CAD-centric data transfers
            in multisite environments, bidirectional product structure editing,
            and using design tables.
          </p>
        </div>

        <div className="migration">
          <h4 className="TINX-page-heading">Migration</h4>
          <p className="plmimplementationparagraph">
            We helps customer to migrate the legacy data by ensuring end to end
            migration process by using CMM efficiently to achieve quality
            migration to optimize CAD processes based on future customer
            business needs.
          </p>
          <h5 className="migration-heading">
            {" "}
            Solid Edge Legacy Data Migration{" "}
          </h5>
          <p className="plmimplementationparagraph">
            We have developed a unique methodology for migrating Solid Edge
            legacy data using bulk data import and export functionalities within
            Teamcenter, which includes:
          </p>
          <ol className="custom-ordered-list">
            <li>Data Assessment & Analysis</li>
            <li>Data Cleanup</li>
            <li>Data Migration and Testing</li>
            <li>Production Rollout</li>
          </ol>
          <h5 className="migration-heading">
            Solid Edge Design Data Migration to NX
          </h5>
          <p className="plmimplementationparagraph">
            We support Solid Edge design data migration to NX, using the
            following process:
          </p>
          <ol className="custom-ordered-list">
            <li>
              Loading Solid Edge data and corresponding metadata into Teamcenter
            </li>
            <li>Configuring the Content Migration Manager for Solid Edge </li>
            <li>
              Establishing a migration and data verification process for models,
              drawings, BOMs, etc.
            </li>
          </ol>
        </div>
      </div>
      <Letsgetintouch />
    </section>
  );
};

export default TeamCenterIntegrationSolidEdge;
